import React, { ReactNode } from 'react';

import './index.less';

import IbTooltip from '../IbTooltip';
import IbIcon from '../IbIcon';
import IbTypography from '../IbTypography';

import { MAIN_CLASS_NAME } from './const';

export interface IIbFormFieldLabelProps {
  className?: string;
  label?: string | ReactNode;
  hint?: string | ReactNode;
}

const IbFormFieldLabel: React.FC<IIbFormFieldLabelProps> = ({ className, label, hint }) => {
  const classes = [MAIN_CLASS_NAME];
  className && classes.push(className);

  return (
    <div className={classes.join(' ')}>
      <IbTypography.Paragraph type="secondary">{label}</IbTypography.Paragraph>
      {hint && (
        <IbTooltip placement="right" title={hint}>
          <IbIcon iconName="help" size={16} />
        </IbTooltip>
      )}
    </div>
  );
};

export default IbFormFieldLabel;
